/** @format */

// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../../../../../types/typings.d.ts" />

import { ModuleWithProviders, NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { LoggerConfig } from '@shared/data-access/services';

@NgModule({
	providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class LogDataAccessModule {
	static forRoot(config: LoggerConfig | undefined): ModuleWithProviders<LogDataAccessModule> {
		return {
			ngModule: LogDataAccessModule,
			providers: [{ provide: LoggerConfig, useValue: config || undefined }]
		};
	}
}
